if (!customElements.get("video-controls")) {
    customElements.define(
      "video-controls",
      class VideoControls extends HTMLElement {
        constructor() {
          super();
        }
        

        connectedCallback() {
          this.video = this.querySelector("video");
          this.hasVideoClickToggle = this.dataset.videoClick === "false" ? false : true;
          this.productsContainer = this.querySelector(
            ".shoppable-video__products",
          );
          this.controlButton = this.querySelector(
            ".shoppable-video__control-button:not(.shoppable-video__control-button--mute)",
          );
          this.muteButton = this.querySelector(
            ".shoppable-video__control-button--mute",
          );
          
          this.togglePlayPause = this.togglePlayPause.bind(this);
          this.toggleVideoIcon = this.toggleVideoIcon.bind(this);
          this.toggleMute = this.toggleMute.bind(this);
          this.toggleMuteIcon = this.toggleMuteIcon.bind(this);

          this.addEventListeners();
          if(this.controlButton && this.video) this.toggleVideoIcon();
          if(this.muteButton && this.video) this.toggleMuteIcon();
        }
        
        addEventListeners() {
          if(this.controlButton) this.controlButton.addEventListener("click", this.togglePlayPause);
          if(this.muteButton) this.muteButton.addEventListener("click", this.toggleMute);
          if(this.video && this.hasVideoClickToggle) this.video.addEventListener("click", this.togglePlayPause);
          if(this.video) {
            if (this.controlButton) {
              this.video.addEventListener("play", this.toggleVideoIcon);
              this.video.addEventListener("pause", this.toggleVideoIcon);
            }
            if (this.muteButton) {
              this.video.addEventListener("volumechange", this.toggleMuteIcon);
            }
          }
        }
        
        removeEventListeners() {
          if(this.controlButton) this.controlButton.removeEventListener("click", this.togglePlayPause);
          if(this.muteButton) this.muteButton.removeEventListener("click", this.toggleMute);
          if(this.video && this.hasVideoClickToggle) this.video.removeEventListener("click", this.togglePlayPause);
          if(this.video) {
            if (this.controlButton) {
              this.video.removeEventListener("play", this.toggleVideoIcon);
              this.video.removeEventListener("pause", this.toggleVideoIcon);
            }
            if (this.muteButton) {
              this.video.removeEventListener("volumechange", this.toggleMuteIcon);
            }
          }
        }

        toggleVideoIcon() {
          const isPlaying = !this.video.paused;
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--play",
            isPlaying,
          );
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--pause",
            !isPlaying,
          );
        }

        toggleMuteIcon() {
          const isMuted = this.video.muted || this.video.volume === 0;
          this.muteButton.classList.toggle(
            "shoppable-video__control-button--muted",
            isMuted,
          );
          this.muteButton.classList.toggle(
            "shoppable-video__control-button--unmuted",
            !isMuted,
          );
        }

        togglePlayPause(e) {
          e.preventDefault();
          const videoElement = this.video;      
          
          if (!videoElement) return;

          if (videoElement.paused || videoElement.ended) {
            videoElement.play();
          } else {
            videoElement.pause();
          }
        }

        toggleMute(e) {
          e.preventDefault();
          e.stopPropagation();
          const videoElement = this.video;
          if (!videoElement) return;

          videoElement.muted = !videoElement.muted;
          this.toggleMuteIcon();
        }

        disconnectedCallback(){
          this.removeEventListeners();
        }

      },
    );
  }
  